import { watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useTenantStore } from '@/tenant/stores/tenantStore';
import type { ThemeConfig } from '@/tenant/types/tenant';

const CSS_VAR_MAP: Record<keyof ThemeConfig, string> = {
  primary: '--color-primary',
  secondary: '--color-secondary',
  accent: '--color-accent',
  textPrimary: '--color-text-primary',
  textSecondary: '--color-text-secondary',
  borderRadius: '--border-radius',
  fontFamily: '--font-family',
};

function applyTheme(theme: ThemeConfig) {
  const root = document.documentElement;
  for (const [key, cssVar] of Object.entries(CSS_VAR_MAP)) {
    const value = theme[key as keyof ThemeConfig];
    if (value) {
      root.style.setProperty(cssVar, value);
    }
  }
}

export function useTheme() {
  const tenantStore = useTenantStore();
  const { theme } = storeToRefs(tenantStore);

  watch(theme, (newTheme) => {
    applyTheme(newTheme);
  }, { immediate: true });

  return { theme, applyTheme };
}
